import { z } from "zod";

export const schemaCondicoesDePagamentoParcelas = z.object({
 CPPcParcela:z.number(),
 CPPcDias:z.string(),
});

export type CondicoesDePagamentoParcelasFormProps = z.infer<typeof schemaCondicoesDePagamentoParcelas>;
